import {Card, Col, Row, Spinner} from "react-bootstrap";
import CredentialsTable from "../../Components/CredentialsTable/CredentialsTable";
import {useState} from "react";
import React from "react";
import CredentialsProperties from "../../Components/CredetialsProperties/CredetialsProperties";

export default function CredentialsPage({
                                            isNoCredentials,
                                            credentialsData,
                                            copyTextToClipboard
                                        }) {
    const [showProperties, setShowProperties] = useState(false);
    const [propertiesData, setPropertiesData] = useState([]);
    const [typeName, setTypeName] = useState('');

    const showPropertiesWithData = (typeName, data) => {
        setTypeName(typeName);
        setPropertiesData(data);
        setShowProperties(true);
    };

    const hideProperties = () => {
        setShowProperties(false);
    };

    return (
        <Row className={'mb-2 mr-1 ml-1'}>
            <Col md={showProperties ? {span: 8, offset: 3} : {span: 5, offset: 4}}>
                <Card bsPrefix='tabCard'>
                    <Card.Body>
                        <Row>
                            <Col md={showProperties ? {span: 7} : {span: 12}}>
                                <CredentialsTable
                                    showPropertiesWithData={showPropertiesWithData}
                                    isNoCredentials={isNoCredentials}
                                    data={credentialsData}
                                    copyTextToClipboard={copyTextToClipboard}
                                />
                            </Col>
                            <Col md={{span: 5}}>
                                {showProperties &&
                                    <CredentialsProperties
                                        typeName={typeName}
                                        properties={propertiesData}
                                        onClose={hideProperties}
                                        copyTextToClipboard={copyTextToClipboard}
                                    />}
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );
}
